var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.total) ? _c('div', {
    attrs: {
      "type": "text/x-template",
      "id": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.first')) + "\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.previous')) + "\n      ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return (page.name > 0) ? _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        active: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page.name) + "\n      ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.next')) + "\n      ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.last')) + "\n      ")])])], 2)]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-562173db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562173db","hasScoped":true}!./src/views/components/shared/pagination/pagination.component.html
// module id = 805
// module chunks = 0